import { createContext, useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const LoadingContext = createContext({ isLoading: false });

const SHOW_DELAY_MS = 150;

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const countRef = useRef(0);
  const showTimerRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || window.__fetchLoaderWrapped) return;
    window.__fetchLoaderWrapped = true;

    const update = () => {
      if (countRef.current > 0) {
        if (showTimerRef.current === null) {
          showTimerRef.current = setTimeout(() => {
            setIsLoading(true);
            showTimerRef.current = null;
          }, SHOW_DELAY_MS);
        }
      } else {
        if (showTimerRef.current !== null) {
          clearTimeout(showTimerRef.current);
          showTimerRef.current = null;
        }
        setIsLoading(false);
      }
    };

    const originalFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      countRef.current += 1;
      update();
      return originalFetch(...args).finally(() => {
        countRef.current = Math.max(0, countRef.current - 1);
        update();
      });
    };
  }, []);

  return <LoadingContext.Provider value={{ isLoading }}>{children}</LoadingContext.Provider>;
}

LoadingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useLoading() {
  return useContext(LoadingContext);
}
